<template>
  <div class="home">
    <nav class="navbar">
      <div class="navbar-brand">
        <img src="./../assets/logo2.png" alt="">
      </div>
      <ul class="nav justify-content-end">
        <li class="nav-item navbar-right">
          <img v-show="active === '/'" alt="">
          <router-link class="nav-link"
                       to="/"
                       :class="{'active': active === '/'}">首页
          </router-link>
        </li>
        <!-- <li class="nav-item navbar-right">
          <img v-show="active === '/activities'" src="./../assets/images/nav_bg.png" alt="">
          <router-link class="nav-link"
                       to="/activities"
                       :class="{'active': active === '/activities'}">近期活动
          </router-link>
        </li>
        <li class="nav-item navbar-right">
          <img v-show="active === 'coop'" src="./../assets/images/nav_bg.png" alt="">
          <router-link class="nav-link"
                       :class="{'active': active === 'coop'}"
                       :to="{ path: '/', query: { anchor: 'coop' }}">投稿合作
          </router-link>
        </li>
        <li class="nav-item navbar-right">
          <img v-show="active === '/news'" src="./../assets/images/nav_bg.png" alt="">
          <router-link class="nav-link"
                       to="/news"
                       :class="{'active': active === '/news'}">资讯动态
          </router-link>
        </li>  -->
        <!-- <li class="nav-item navbar-right">
          <a class="nav-link" target="_blank"
             href="https://www.zhipin.com/gongsir/9d32223f7895bbe903Z_0tW7FQ~~.html?page=1&ka=page-1">人才招聘</a>
        </li> -->
        <li class="nav-item navbar-right">
          <img v-show="active === 'about'" alt="">
          <router-link class="nav-link"
                       :class="{'active': active === '/about'}"
                       to="/about">关于我们
          </router-link>
        </li>
        <li class="nav-item navbar-right">
          <img v-show="active === '/recharge'" alt="">
          <router-link class="nav-link"
                       to="/recharge"
                       :class="{'active': active === '/recharge'}">充值
          </router-link>
        </li>
        <li class="nav-item navbar-right">
          <img v-show="active === '/login'" alt="">
          <router-link class="nav-link"
                       to="/login"
                       :class="{'active': active === '/login'}">登录
          </router-link>
        </li>
        <li class="nav-item navbar-right">
          <img v-show="active === '/register'" alt="">
          <router-link class="nav-link"
                       to="/register"
                       :class="{'active': active === '/register'}">注册
          </router-link>
        </li> 
      </ul>
    </nav>
    <div>
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  watch: {
    '$route': 'getPath'
  },
  data() {
    return {
      active: '/',
    }
  },
  mounted() {
    this.getPath();
  },
  methods: {
    getPath() {
      const anchor = this.$route.query.anchor
      if (anchor) {
        this.active = anchor;
      } else {
        this.active = this.$route.path;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.home {
    margin: 0;
    padding: 0;
    min-height: 100%;
    max-height: 100vh;
}


.navbar {
  /* background: #000; */
  position: fixed;
  top: 0;
  left: 0;
  margin-top: 40px;
  width: 100%;
  z-index: 200;
  height: 70px;
  /*max-height: 72px;*/
}

.navbar-brand {
  margin-left: 120px;
}

.navbar-brand img:nth-of-type(1) {
  width: 100px;
  height: 41px;
  margin-right: 25px;
}


.nav {
  margin-right: 120px;
}

.nav-link {
  cursor: pointer;
  line-height: 70px;
  /*min-width: 75px;*/
  /*min-height: 26px;*/
  font-size: 16px;
  font-family: 'YouSheBiaoTiHei';
  color: #FFFFFF;
  letter-spacing: 0.26px;
  padding: 0 25px;

  /*line-height: 26px;*/
  /*padding: 16px 22px;*/
}

.active {
  /*font-size: 28px;*/
  font-size: 22px;
  letter-spacing: 0.36px;
  font-weight: 400;
}

.nav-item {
  position: relative;
}

.nav-item img {
  position: absolute;
  left: 0;
  top: 47%;
  z-index: -1;
  width: 98%;
}

</style>
